module.exports = __webpack_public_path__ + "img/ad05.c31ed973.png";